import React from 'react';
import CloseIcon from '@material-ui/icons/Close';

const CloseButton = ({
  tamanho,
  tamanhoIcone,
  corBackground,
  borderColor,
  marginRight,
  marginTop,
  color,
  onClick,
  id,
  disabled,
  tabIndex,
}) => {
  return (
    <button
      style={{
        borderRadius: '50%',
        fontSize: tamanhoIcone,
        border: `1px solid ${borderColor || '#848484'}`,
        backgroundColor: corBackground || 'transparent',
        color: color ?? '#B61817',
        fontWeight: '900',
        width: tamanho,
        height: tamanho,
        textDecoration: 'none',
        marginRight: marginRight ?? '5px',
        marginTop: marginTop ?? '0px',
        zIndex: '999999999999999999999999999',
        cursor: 'pointer',
        pointerEvents: disabled ? 'none' : 'all',
        opacity: disabled ? '0.6' : '1',
      }}
      className='centralized'
      onClick={onClick}
      id={id}
      tabIndex={tabIndex}
    >
      <CloseIcon style={{ fontSize: tamanhoIcone }} />
    </button>
  );
};

export default CloseButton;
